export default __webpack_public_path__ + "static/media/build.29c3d40e.svg";